import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../config/Api";
import { Deal, DealReq } from "../../types/dealType";
import { ApiResponse } from "../../types/apiResponse";


export const createDeal = createAsyncThunk<Deal,DealReq>(
    "deal/createDeal", // Action type
    async (deal: DealReq, { rejectWithValue }) => {
      try {
        // Make the API POST request
        const response = await api.post("/admin/deals/create", deal)
  
        return response.data; // Return the successful response data
      } catch (error: any) {
      
  
        // Handle error and reject with a meaningful message
        return rejectWithValue(
          error.response?.data?.message || "Failed to create deal"
        );
      }
    }
  );

  export const getAllDeals = createAsyncThunk<Deal[],void>(
    "deal/getAllDeals",
    async (_, { rejectWithValue }) => {
      try {
        const response = await api.get("/admin/deals");
      
        return response.data;
      } catch (error: any) {
    
        return rejectWithValue(
          error.response?.data?.message || "Failed to fetch deals"
        );
      }
    }
  );

  export const deleteDeal = createAsyncThunk<ApiResponse<Deal>,number>(
    "deal/deleteDeal",
    async (dealId, { rejectWithValue }) => {
      try {
        const response = await api.delete(`/admin/deals/${dealId}`);
        
        return response.data;
      } catch (error: any) {
       
        return rejectWithValue(
          error.response?.data?.message || "Failed to fetch deals"
        );
      }
    }
  );
  export interface DealsState {
    deals: Deal[];
    loading: boolean;
    error: string | null;
    dealCreated: boolean;
    dealUpdated: boolean;
    dealDeleted:boolean;
  }
  
  
  const initialState:DealsState = {
    deals: [],
    loading: false,
    error: null,
    dealCreated: false,
    dealUpdated:false,
    dealDeleted:false
  };
  
  const dealSlice = createSlice({
    name: "deal",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      // Handle pending state for createDeal
      builder.addCase(createDeal.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.dealCreated = false;
      });
  
      // Handle fulfilled state for createDeal
      builder.addCase(createDeal.fulfilled, (state, action:PayloadAction<Deal>) => {
        state.loading = false;
        if(state.deals){
            state.deals.push(action.payload);
        }
        state.dealCreated = true;
      });
  
      // Handle rejected state for createDeal
      builder.addCase(createDeal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.dealCreated = false;
      });
  
      // Handle pending state for getAllDeals
      builder.addCase(getAllDeals.pending, (state) => {
        state.loading = true;
        state.error = null;
        
      });
  
      // Handle fulfilled state for getAllDeals
      builder.addCase(getAllDeals.fulfilled, (state, action) => {
        state.loading = false;
        state.deals = action.payload;
        // state.dealCreated=false;
        // state.dealDeleted=false;
      });
  
      // Handle rejected state for getAllDeals
      builder.addCase(getAllDeals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });


      // delete deal


      builder.addCase(deleteDeal.pending, (state) => {
        state.loading = true;
        state.error = null;
        
      });
  
      // Handle fulfilled state for deleteDeal
      builder.addCase(deleteDeal.fulfilled, (state, action:PayloadAction<ApiResponse<Deal>>) => {
        state.loading = false;
        state.dealDeleted = action.payload.success;
       state.deals = state.deals.filter((item)=>item.id!=action.payload.data?.id)
        
      });
  
      // Handle rejected state for deleteDeal
      builder.addCase(deleteDeal.rejected, (state, action) => {
        state.loading = false;
        state.dealDeleted = false;
        state.error = action.payload as string;
      });
    },
  });
  
  export const dealSliceReducer = dealSlice.reducer;